import { combineReducers } from "redux";
import userReducer from "./user";
import organizationsReducer from "./organizations";

export default combineReducers({
  user: userReducer,
  organizations: organizationsReducer,
});
